export const getHost = () => {
  return typeof window !== "undefined"
    ? window.location.host
    : import.meta.env.VITE_API_BASE_DEFAULT;
};

export const getOrigin = () => {
  return typeof window !== "undefined" ? window.location.origin : "";
};

export const getSubdomain = () => {
  return getHost().split(".")[0];
};

export const getOrganization = () => {
  const subdomain = getSubdomain();
  // Replace hyphens with spaces and remove non-alphabetic characters
  const cleanSubdomain = subdomain
    .replace(/[^a-zA-Z-]/g, "")
    .replace(/-/g, " ");
  // Capitalize the first letter of each word
  return cleanSubdomain.replace(/\b\w/g, (char: string) => char.toUpperCase());
};

export const getBaseUrl = () => {
  return `${import.meta.env.VITE_API_BASE_URL?.replace(
    import.meta.env.VITE_MAIN_SUBDOMAIN,
    getSubdomain(),
  )}`;
};